import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import ContactModal from "../ContactModal";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Grid, ListItemText, MenuItem, Select } from "@material-ui/core";
import { toast } from "react-toastify";
import { Facebook, Instagram, WhatsApp } from "@material-ui/icons";
import ShowTicketOpen from "../ShowTicketOpenModal";

const useStyles = makeStyles((theme) => ({
  online: {
    fontSize: 11,
    color: "#25d366"
  },
  offline: {
    fontSize: 11,
    color: "#e1306c"
  }
}));

const filter = createFilterOptions({
  trim: true,
});

const NewTicketModal = ({
  modalOpen,
  onClose,
  initialContact,
  withInitialMessage = false
}) => {
  const classes = useStyles();
  const [options, setOptions] = useState([]);
  const [channelFilter, setChannelFilter] = useState(null);

  const [loading, setLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState("");
  const [selectedWhatsapp, setSelectedWhatsapp] = useState("");
  const [initialMessage, setInitialMessage] = useState("");
  const [newContact, setNewContact] = useState({});
  const [whatsapps, setWhatsapps] = useState([]);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const { user } = useContext(AuthContext);
  const { companyId, whatsappId } = user;

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");
  const [existingConversation, setExistingConversation] = useState(null);
  const [selectedActiveTicketId, setSelectedActiveTicketId] = useState(null);
  useEffect(() => {
    if (initialContact?.id !== undefined) {
      setOptions([initialContact]);
      setSelectedContact(initialContact);
    }
  }, [initialContact]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        api
          // .get(`/whatsapp/filter`, { params: { companyId, session: 0, channel: channelFilter } })
          .get(`/whatsapp`, { params: { companyId, session: 0 } })
          .then(({ data }) => setWhatsapps(data));

          // .then(({ data }) => {
          //   const mappedWhatsapps = data.map((whatsapp) => ({
          //     ...whatsapp,
          //     selected: false,
          //   }));
          //   setWhatsapps(mappedWhatsapps);
          //   if (channelFilter && mappedWhatsapps.length && mappedWhatsapps?.length === 1 && (user.whatsappId === null || user?.whatsapp?.channel !== channelFilter)) {
          //     setSelectedWhatsapp(mappedWhatsapps[0].id)
          //   }
          // });
      };

      if (whatsappId !== null && whatsappId !== undefined) {
        setSelectedWhatsapp(whatsappId)
      }

      if (user.queues.length === 1) {
        setSelectedQueue(user.queues[0].id)
      }
      fetchContacts();
      setLoading(false);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [selectedContact, channelFilter])

  useEffect(() => {
    if (!modalOpen || searchParam.length < 3) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get("contacts", {
            params: { searchParam },
          });
          setOptions(data.contacts);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, modalOpen]);

  const IconChannel = (channel) => {
    switch (channel) {
      case "facebook":
        return <Facebook style={{ color: "#3b5998", verticalAlign: "middle" }} />;
      case "instagram":
        return <Instagram style={{ color: "#e1306c", verticalAlign: "middle" }} />;
      case "whatsapp":
        return <WhatsApp style={{ color: "#25d366", verticalAlign: "middle" }} />
      default:
        return "error";
    }
  };

  const handleClose = () => {
    onClose();
    setSearchParam("");
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
    setSelectedContact(null);
    setExistingConversation(null);
    setInitialMessage("");
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setLoading(false);
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
  };

  const handleSaveTicket = async (
    contactId,
    options = {}
  ) => {

    const {
      forceClaim = false,
      snapshot = null,
      selectedExistingTicketId = null
    } = options;


    if (!contactId) {

      toast.error(
        "Selecione um contato"
      );

      return;
    }


    if (
      !withInitialMessage &&
      selectedQueue === ""
    ) {

      toast.error(
        "Selecione uma fila"
      );

      return;
    }


    if (
      withInitialMessage &&
      selectedWhatsapp === ""
    ) {

      toast.error(
        "Selecione uma conexão"
      );

      return;
    }


    const cleanInitialMessage =
      String(
        initialMessage ||
        ""
      ).trim();





    setLoading(
      true
    );


    let ticket =
      null;


    const queueId =
      selectedQueue !== ""
        ? selectedQueue
        : null;


    const whatsappId =
      selectedWhatsapp !== ""
        ? selectedWhatsapp
        : null;


    try {

      const payload = {
        contactId,
        queueId,
        whatsappId,

        userId:
          user.id,

        status:
          "open",

        forceClaim:
          forceClaim === true,

        selectedExistingTicketId:
          selectedExistingTicketId ||
          undefined
      };


      if (
        forceClaim &&
        snapshot?.current
      ) {

        payload.expectedTicketId =
          Number(
            snapshot
              ?.current
              ?.ticketId ||
            0
          );

        payload.expectedOwnerId =
          Number(
            snapshot
              ?.current
              ?.user
              ?.id ||
            0
          );

        payload.expectedQueueId =
          Number(
            snapshot
              ?.current
              ?.queue
              ?.id ||
            0
          );

        payload.expectedWhatsappId =
          Number(
            snapshot
              ?.current
              ?.whatsapp
              ?.id ||
            0
          );

        payload.expectedStatus =
          String(
            snapshot
              ?.current
              ?.status ||
            ""
          );
      }


      const response =
        await api.post(
          "/tickets",
          payload
        );


      ticket =
        response.data;


    } catch (err) {

      const rawError =
        err
          ?.response
          ?.data
          ?.error;


      let parsed =
        null;


      if (
        rawError &&
        typeof rawError ===
          "object"
      ) {

        parsed =
          rawError;

      } else if (
        typeof rawError ===
        "string"
      ) {

        try {

          parsed =
            JSON.parse(
              rawError
            );

        } catch (_) {

          parsed =
            null;
        }
      }


      /*
       * REGRA ABSOLUTA:
       * qualquer conversa anterior chega aqui.
       */
      if (
        Number(
          err
            ?.response
            ?.status
        ) === 409 &&
        (
          parsed?.code ===
            "EXISTING_CONVERSATION_CONFIRMATION" ||
          parsed?.code ===
            "MULTIPLE_ACTIVE_TICKETS"
        )
      ) {

        setExistingConversation({
          ...parsed,

          contactId:
            Number(
              contactId
            )
        });


        if (
          parsed?.code ===
          "MULTIPLE_ACTIVE_TICKETS"
        ) {
          setSelectedActiveTicketId(
            null
          );
        }


        setLoading(
          false
        );

        return;
      }


      /*
       * Compatibilidade com comportamento legado.
       */
      const legacyTicket =
        parsed?.ticket?.id
          ? parsed.ticket
          : parsed?.id
          ? parsed
          : null;


      if (
        legacyTicket?.id
      ) {

        setExistingConversation({
          code:
            "EXISTING_CONVERSATION_CONFIRMATION",

          message:
            "Este contato já possui uma conversa na KORAX.",

          contactId:
            Number(
              contactId
            ),

          ticketCount:
            1,

          current: {
            ticketId:
              legacyTicket.id,

            uuid:
              legacyTicket.uuid,

            status:
              legacyTicket.status,

            updatedAt:
              legacyTicket.updatedAt,

            user:
              legacyTicket.user || {
                id:
                  legacyTicket.userId ||
                  null,

                name:
                  null
              },

            queue:
              legacyTicket.queue || {
                id:
                  legacyTicket.queueId ||
                  null,

                name:
                  null
              },

            whatsapp:
              legacyTicket.whatsapp || {
                id:
                  legacyTicket.whatsappId ||
                  null,

                name:
                  null
              }
          },

          destination: {
            user: {
              id:
                user.id,

              name:
                user.name
            },

            queue: {
              id:
                queueId,

              name:
                null
            },

            whatsapp: {
              id:
                whatsappId,

              name:
                null
            }
          }
        });


        setLoading(
          false
        );

        return;
      }


      setLoading(
        false
      );

      toastError(
        err
      );

      return;
    }


    if (
      !ticket?.id
    ) {

      setLoading(
        false
      );

      toast.error(
        "Não foi possível iniciar a conversa"
      );

      return;
    }


    /*
     * A mensagem inicial so sai depois
     * de toda confirmacao.
     */
    if (
      withInitialMessage &&
      cleanInitialMessage
    ) {

      try {

        await api.post(
          `/messages/${ticket.id}`,
          {
            read:
              1,

            fromMe:
              true,

            mediaUrl:
              "",

            body:
              cleanInitialMessage,

            quotedMsg:
              null,

            isPrivate:
              "false"
          }
        );

      } catch (err) {

        setLoading(
          false
        );

        toastError(
          err
        );

        return;
      }
    }


    setExistingConversation(
      null
    );

    setInitialMessage(
      ""
    );

    setLoading(
      false
    );


    onClose(
      ticket
    );
  };


  const handleCancelExistingConversation =
    () => {

      setExistingConversation(
        null
      );

      setSelectedActiveTicketId(
        null
      );

      setLoading(
        false
      );
    };


  const handleConfirmExistingConversation =
    () => {

      if (
        !existingConversation
      ) {

        return;
      }


      const contactId =
        Number(
          existingConversation
            ?.contactId ||
          0
        );


      if (
        contactId <= 0
      ) {

        return;
      }


      /*
       * CASO 1:
       * existem varios tickets ativos.
       *
       * O usuario escolhe explicitamente
       * qual conversa deseja continuar.
       */
      if (
        existingConversation
          ?.code ===
          "MULTIPLE_ACTIVE_TICKETS"
      ) {

        const selectedTicket =
          (
            existingConversation
              ?.tickets ||
            []
          ).find(
            item =>
              Number(
                item?.id
              ) ===
              Number(
                selectedActiveTicketId
              )
          );


        if (
          !selectedTicket
        ) {

          toast.error(
            "Selecione qual conversa deseja continuar"
          );

          return;
        }


        const selectedSnapshot = {
          current: {
            ticketId:
              Number(
                selectedTicket.id
              ),

            uuid:
              selectedTicket.uuid,

            status:
              String(
                selectedTicket.status ||
                ""
              ),

            user: {
              id:
                Number(
                  selectedTicket
                    ?.user
                    ?.id ||
                  selectedTicket
                    ?.userId ||
                  0
                ) || null,

              name:
                selectedTicket
                  ?.user
                  ?.name ||
                null
            },

            queue: {
              id:
                Number(
                  selectedTicket
                    ?.queue
                    ?.id ||
                  selectedTicket
                    ?.queueId ||
                  0
                ) || null,

              name:
                selectedTicket
                  ?.queue
                  ?.name ||
                null
            },

            whatsapp: {
              id:
                Number(
                  selectedTicket
                    ?.whatsapp
                    ?.id ||
                  selectedTicket
                    ?.whatsappId ||
                  0
                ) || null,

              name:
                selectedTicket
                  ?.whatsapp
                  ?.name ||
                null
            }
          }
        };


        handleSaveTicket(
          contactId,
          {
            forceClaim:
              true,

            selectedExistingTicketId:
              Number(
                selectedTicket.id
              ),

            snapshot:
              selectedSnapshot
          }
        );


        return;
      }


      /*
       * CASO 2:
       * apenas uma conversa existente.
       */
      handleSaveTicket(
        contactId,
        {
          forceClaim:
            true,

          snapshot:
            existingConversation
        }
      );
    };


  const ticketStatusLabel =
    status => {

      switch (
        String(
          status ||
          ""
        )
      ) {

        case "open":
          return "Em atendimento";

        case "pending":
          return "Recepção";

        case "closed":
          return "Finalizado";

        case "group":
          return "Grupo";

        default:
          return status || "Não informado";
      }
    };


  const handleSelectOption = (e, newValue) => {
    if (newValue?.number) {
      setSelectedContact(newValue);
    } else if (newValue?.name) {
      setNewContact({ name: newValue.name });
      setContactModalOpen(true);
    }
  };

  const handleCloseContactModal = () => {
    setContactModalOpen(false);
  };

  const handleAddNewContactTicket = contact => {
    setSelectedContact(contact);
  };

  const createAddContactOption = (filterOptions, params) => {
    const filtered = filter(filterOptions, params);
    if (params.inputValue !== "" && !loading && searchParam.length >= 3) {
      filtered.push({
        name: `${params.inputValue}`,
      });
    }
    return filtered;
  };

  const renderOption = option => {
    if (option.number) {
      return <>
        {IconChannel(option.channel)}
        <Typography component="span" style={{ fontSize: 14, marginLeft: "10px", display: "inline-flex", alignItems: "center", lineHeight: "2" }}>
          {option.name} - {option.number}
        </Typography>
      </>
    } else {
      return `${i18n.t("newTicketModal.add")} ${option.name}`;
    }
  };

  const renderOptionLabel = option => {
    if (option.number) {
      return `${option.name} - ${option.number}`;
    } else {
      return `${option.name}`;
    }
  };

  const renderContactAutocomplete = () => {
    if (initialContact === undefined || initialContact.id === undefined) {
      return (
        <Grid xs={12} item>
          <Autocomplete
            fullWidth
            options={options}
            loading={loading}
            clearOnBlur
            autoHighlight
            freeSolo
            clearOnEscape
            getOptionLabel={renderOptionLabel}
            renderOption={renderOption}
            filterOptions={createAddContactOption}
            onChange={(e, newValue) => {                     
              setChannelFilter(newValue ? newValue.channel : "whatsapp");
              handleSelectOption(e, newValue)
            }}
            renderInput={params => (
              <TextField
                {...params}
                label={i18n.t("newTicketModal.fieldLabel")}
                variant="outlined"
                autoFocus
                onChange={e => setSearchParam(e.target.value)}
                onKeyPress={e => {
                  if (
                    loading ||
                    !selectedContact ||
                    (
                      withInitialMessage &&
                      (
                        !selectedWhatsapp
                      )
                    )
                  ) {
                    return;
                  }

                  if (e.key === "Enter") {
                    handleSaveTicket(selectedContact.id);
                  }
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      )
    }
    return null;
  }

  return (
    <>

      <Dialog open={modalOpen} onClose={handleClose}>
        <DialogTitle id="form-dialog-title">
          {i18n.t("newTicketModal.title")}
        </DialogTitle>
        <DialogContent dividers>
          <Grid style={{ width: 300 }} container spacing={2}>
            {/* CONTATO */}
            {renderContactAutocomplete()}
            {!withInitialMessage && (
              <>
            {/* FILA */}
            <Grid xs={12} item>
              <Select
                required
                fullWidth
                displayEmpty
                variant="outlined"
                value={selectedQueue}
                onChange={(e) => {
                  setSelectedQueue(e.target.value)
                }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                renderValue={() => {
                  if (selectedQueue === "") {
                    return "Selecione uma fila"
                  }
                  const queue = user.queues.find(q => q.id === selectedQueue)
                  return queue.name
                }}
              >
                {user.queues?.length > 0 &&
                  user.queues.map((queue, key) => (
                    <MenuItem dense key={key} value={queue.id}>
                      <ListItemText primary={queue.name} />
                    </MenuItem>
                  ))
                }
              </Select>
            </Grid>
              </>
            )}

            {/* CONEXAO */}
            <Grid xs={12} item>
              <Select
                required
                fullWidth
                displayEmpty
                variant="outlined"
                value={selectedWhatsapp}
                onChange={(e) => {
                  setSelectedWhatsapp(e.target.value)
                }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                renderValue={() => {
                  if (selectedWhatsapp === "") {
                    return "Selecione uma Conexão"
                  }
                  const whatsapp = whatsapps.find(w => w.id === selectedWhatsapp)
                  return whatsapp?.name
                }}
              >
                {whatsapps?.length > 0 &&
                  whatsapps.map((whatsapp, key) => (
                    <MenuItem dense key={key} value={whatsapp.id}>
                      <ListItemText
                        primary={
                          <>
                            {IconChannel(whatsapp.channel)}
                            <Typography component="span" style={{ fontSize: 14, marginLeft: "10px", display: "inline-flex", alignItems: "center", lineHeight: "2" }}>
                              {whatsapp.name} &nbsp; <p className={(whatsapp.status) === 'CONNECTED' ? classes.online : classes.offline} >({whatsapp.status})</p>
                            </Typography>
                          </>
                        }
                      />
                    </MenuItem>
                  ))}
              </Select>
            </Grid>

            {withInitialMessage && (
              <Grid xs={12} item>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  label="Mensagem inicial (opcional)"
                  placeholder="Digite a primeira mensagem para o cliente"
                  value={initialMessage}
                  disabled={loading}
                  onChange={e =>
                    setInitialMessage(
                      e.target.value
                    )
                  }
                  inputProps={{
                    maxLength: 4096
                  }}
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            disabled={loading}
            variant="outlined"
          >
            {i18n.t("newTicketModal.buttons.cancel")}
          </Button>
          <ButtonWithSpinner
            variant="contained"
            type="button"
            disabled={
              loading ||
              !selectedContact ||
              (
                withInitialMessage &&
                (
                  !selectedWhatsapp
                )
              )
            }
            onClick={() =>
              handleSaveTicket(
                selectedContact?.id
              )
            }
            color="primary"
            loading={loading}
          >
            {i18n.t("newTicketModal.buttons.ok")}
          </ButtonWithSpinner>
        </DialogActions>
        {existingConversation && (
          <Dialog
            open={
              Boolean(
                existingConversation
              )
            }
            onClose={
              loading
                ? undefined
                : handleCancelExistingConversation
            }
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>
              {existingConversation
                ?.code ===
                "MULTIPLE_ACTIVE_TICKETS"
                ? "Mais de uma conversa ativa"
                : "Conversa já existente na KORAX"}
            </DialogTitle>


            <DialogContent
              dividers
            >

              {existingConversation
                ?.code ===
                "MULTIPLE_ACTIVE_TICKETS"
                ? (
                  <>
                    <Typography
                      style={{
                        fontSize: 14,
                        lineHeight: 1.6,
                        color: "#344054"
                      }}
                    >
                      Este contato possui mais de
                      uma conversa ativa.
                      Selecione qual atendimento
                      deseja continuar.
                    </Typography>


                    <Typography
                      style={{
                        marginTop: 6,
                        fontSize: 12,
                        lineHeight: 1.5,
                        color: "#667085"
                      }}
                    >
                      Nenhuma conversa será
                      alterada até você confirmar.
                    </Typography>


                    <div
                      style={{
                        marginTop: 16,
                        display: "grid",
                        gap: 10
                      }}
                    >
                      {(existingConversation
                        ?.tickets ||
                        []).map(
                        item => {

                          const selected =
                            Number(
                              selectedActiveTicketId
                            ) ===
                            Number(
                              item.id
                            );


                          return (
                            <div
                              key={
                                item.id
                              }
                              onClick={
                                () =>
                                  setSelectedActiveTicketId(
                                    Number(
                                      item.id
                                    )
                                  )
                              }
                              style={{
                                padding: 14,
                                border:
                                  selected
                                    ? "2px solid #0057FF"
                                    : "1px solid #E4E7EC",
                                borderRadius: 10,
                                background:
                                  selected
                                    ? "#F5F8FF"
                                    : "#F9FAFB",
                                cursor:
                                  "pointer"
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: 13,
                                  fontWeight: 800,
                                  color: "#101828"
                                }}
                              >
                                Ticket #{item.id}
                              </Typography>


                              <Typography
                                style={{
                                  marginTop: 7,
                                  fontSize: 12.5,
                                  lineHeight: 1.75,
                                  color: "#667085"
                                }}
                              >
                                Responsável:{" "}
                                <strong>
                                  {item
                                    ?.user
                                    ?.name ||
                                    "Sem responsável"}
                                </strong>

                                <br />

                                Setor:{" "}
                                <strong>
                                  {item
                                    ?.queue
                                    ?.name ||
                                    "Sem setor"}
                                </strong>

                                <br />

                                WhatsApp:{" "}
                                <strong>
                                  {item
                                    ?.whatsapp
                                    ?.name ||
                                    "Não identificado"}
                                </strong>

                                <br />

                                Status:{" "}
                                <strong>
                                  {ticketStatusLabel(
                                    item.status
                                  )}
                                </strong>
                              </Typography>


                              <Button
                                size="small"
                                color="primary"
                                variant={
                                  selected
                                    ? "contained"
                                    : "outlined"
                                }
                                style={{
                                  marginTop: 10
                                }}
                                onClick={
                                  event => {

                                    event.stopPropagation();

                                    setSelectedActiveTicketId(
                                      Number(
                                        item.id
                                      )
                                    );
                                  }
                                }
                              >
                                {selected
                                  ? "Conversa selecionada"
                                  : "Selecionar conversa"}
                              </Button>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </>
                )
                : (
                  <>
                    <Typography
                      style={{
                        fontSize: 14,
                        lineHeight: 1.65,
                        color: "#344054"
                      }}
                    >
                      {existingConversation
                        ?.message ||
                        "Este contato já possui histórico de conversa na KORAX."}
                    </Typography>


                    <div
                      style={{
                        marginTop: 16,
                        padding: 14,
                        border:
                          "1px solid #E4E7EC",
                        borderRadius: 10,
                        background:
                          "#F9FAFB"
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: 12,
                          fontWeight: 800,
                          marginBottom: 9,
                          color: "#101828"
                        }}
                      >
                        Conversa existente
                      </Typography>

                      <Typography
                        style={{
                          fontSize: 13,
                          lineHeight: 1.8,
                          color: "#475467"
                        }}
                      >
                        Responsável:{" "}
                        <strong>
                          {existingConversation
                            ?.current
                            ?.user
                            ?.name ||
                            "Sem responsável"}
                        </strong>

                        <br />

                        Setor:{" "}
                        <strong>
                          {existingConversation
                            ?.current
                            ?.queue
                            ?.name ||
                            "Sem setor"}
                        </strong>

                        <br />

                        WhatsApp:{" "}
                        <strong>
                          {existingConversation
                            ?.current
                            ?.whatsapp
                            ?.name ||
                            "Não identificado"}
                        </strong>

                        <br />

                        Status:{" "}
                        <strong>
                          {ticketStatusLabel(
                            existingConversation
                              ?.current
                              ?.status
                          )}
                        </strong>
                      </Typography>
                    </div>


                    <div
                      style={{
                        marginTop: 12,
                        padding: 14,
                        border:
                          "1px solid #D6E4FF",
                        borderRadius: 10,
                        background:
                          "#F5F8FF"
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: 12,
                          fontWeight: 800,
                          marginBottom: 9,
                          color: "#101828"
                        }}
                      >
                        Se você confirmar
                      </Typography>

                      <Typography
                        style={{
                          fontSize: 13,
                          lineHeight: 1.8,
                          color: "#475467"
                        }}
                      >
                        Responsável:{" "}
                        <strong>
                          {existingConversation
                            ?.destination
                            ?.user
                            ?.name ||
                            user?.name ||
                            "Você"}
                        </strong>

                        <br />

                        Setor:{" "}
                        <strong>
                          {existingConversation
                            ?.destination
                            ?.queue
                            ?.name ||
                            existingConversation
                              ?.current
                              ?.queue
                              ?.name ||
                            "Sem setor"}
                        </strong>

                        <br />

                        WhatsApp:{" "}
                        <strong>
                          {existingConversation
                            ?.destination
                            ?.whatsapp
                            ?.name ||
                            existingConversation
                              ?.current
                              ?.whatsapp
                              ?.name ||
                            "Conexão selecionada"}
                        </strong>
                      </Typography>
                    </div>
                  </>
                )}
            </DialogContent>


            <DialogActions
              style={{
                padding:
                  "14px 24px 20px"
              }}
            >
              <Button
                variant="outlined"
                onClick={
                  handleCancelExistingConversation
                }
                disabled={
                  loading
                }
              >
                Cancelar
              </Button>


              <ButtonWithSpinner
                variant="contained"
                color="primary"
                loading={
                  loading
                }
                disabled={
                  loading ||
                  (
                    existingConversation
                      ?.code ===
                      "MULTIPLE_ACTIVE_TICKETS" &&
                    !selectedActiveTicketId
                  )
                }
                onClick={
                  handleConfirmExistingConversation
                }
              >
                {existingConversation
                  ?.code ===
                  "MULTIPLE_ACTIVE_TICKETS"
                  ? "Assumir conversa"
                  : existingConversation
                      ?.current
                      ?.status ===
                      "closed"
                  ? "Reabrir conversa"
                  : (
                      existingConversation
                        ?.changes
                        ?.whatsapp ||
                      existingConversation
                        ?.changes
                        ?.queue
                    )
                  ? "Assumir e migrar"
                  : existingConversation
                      ?.changes
                      ?.owner
                  ? "Assumir conversa"
                  : "Abrir conversa"}
              </ButtonWithSpinner>
            </DialogActions>
          </Dialog>
        )}

        {contactModalOpen && (
          <ContactModal
            open={contactModalOpen}
            initialValues={newContact}
            onClose={handleCloseContactModal}
            onSave={handleAddNewContactTicket}
          ></ContactModal>
        )}
        {openAlert && (
          <ShowTicketOpen
            isOpen={openAlert}
            handleClose={handleCloseAlert}
            user={userTicketOpen}
            queue={queueTicketOpen}
          />
        )}
      </Dialog >
    </>
  );
};
export default NewTicketModal;